import { render, staticRenderFns } from "./VehicleResume.vue?vue&type=template&id=4f1abd74&"
import script from "./VehicleResume.vue?vue&type=script&lang=js&"
export * from "./VehicleResume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports